<template>
<div style="background-color: white" class="">
    <v-dialog light persistent v-model="cambiaGaraToggle" width="340px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table style="width: 100%" class="mb-3">
                <tr>
                    <td class="cardStatsHeader pa-1">
                        CAMBIA GARA
                    </td>
                </tr>
                <tr v-for="n in getDivisioni()" :key="'DIV_'+n.valore">
                    <td class="pa-1 cardStats" @click="cambiaGara(n.valore)">
                        <strong>{{ n.descrizione }} </strong>
                    </td>
                </tr>
            </table>
            <v-btn round class="grey lighten-2 black--text" @click="cambiaGaraToggle=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="cambiaVisualizzazioneToggle" width="340px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table style="width: 100%" class="mb-3">
                <tr>
                    <td class="cardStatsHeader pa-1">
                        CAMBIA VISUALIZZAZIONE
                    </td>
                </tr>
                <tr v-for="n in getVisualizzazioni()" :key="'VIS_'+n.valore">
                    <td class="pa-1 cardStats" @click="cambiaVisualizzazione(n.valore)">
                        <strong>{{ n.descrizione }} </strong>
                    </td>
                </tr>
            </table>
            <v-btn round class="grey lighten-2 black--text" @click="cambiaVisualizzazioneToggle=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="filtroDialog" width="340px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <v-flex v-if="mostraSesso" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaSesso" v-model="sessoSelected" :label="'Sesso'" single-line persistent-hint :hint="'Sesso'" @input="changedSex"></v-select>
            </v-flex>
            <v-flex  v-if="mostraCategorie" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaCategorie" v-model="categoriaSelected" :label="'- seleziona categoria -'" single-line persistent-hint :hint="'Categoria'" @input="changedCategoria"></v-select>
            </v-flex>
             <v-flex  v-if="mostraSquadre" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaSquadre" v-model="squadraSelected" :label="'- seleziona squadra - '" single-line persistent-hint :hint="'Squadra'" @input="changedSquadra"></v-select>
            </v-flex>
              <v-flex  v-if="mostraNazione" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-select :items="listaNazioni" v-model="nazioneSelected" :label="'- seleziona nazione - '" single-line persistent-hint :hint="'Nazione'" @input="changedNazione"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-btn small round outline class="red--text" @click="annullaFiltro()">Annulla filtro</v-btn>
                    <v-btn small round outline class="green--text" @click="filtroDialog=false">Applica</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="dettaglio" class="cardUp" width="500px" scrollable style="max-width:500px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="currentItem != undefined" style="width: 100%" class="">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                        <strong style="float: left">
                            <span class="mr-2 ml-1 white--text">{{ currentItem.pett }}</span>

                            <country-flag :country="currentItem.nazione" size="small" class="" />
                            {{currentItem.cognome }}
                            {{ currentItem.nome }}
                            <br />
                            <span class="ml-5">
                                <small>{{
                                                        currentItem.squadra
                                                    }} </small></span>
                        </strong>
                        <v-icon @click="dettaglio=false" class="ma-0 pa-0 white--text" style="float:right">close</v-icon>
                    </td>
                </tr>
            </table>
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                <tr v-for="n in getDetailFields()" :key="'dettaglioRow'+n.id">
                    <td v-if="n.label !== ''" width="40%" class="pr-2 frazioniTitle frazioniValueR">
                        <strong>{{ n.label.toUpperCase() }}</strong>
                    </td>
                    <td v-else width="40%" class="white">
                        <strong>{{ n.label }}</strong>
                    </td>
                    <td width="60%" :style="n.style">
                        <span class="mr-2">{{ getFieldValue(currentItem, n) }}</span>
                    </td>
                </tr>
                <tr>
                    <td width="40%" class="pr-2 frazioniTitle frazioniValueR">
                        <strong>DIPLOMA</strong>
                    </td>
                    <td width="60%" style="text-align: center">
                        <span class="mr-2" @click="downloadDiploma(currentItem)">Scarica</span>
                    </td>
                </tr>
            </table>
            <v-btn round outline small class="black  black--text" @click="dettaglio=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>

    <v-toolbar app color="white" >
        <img class="menuLogo ml-0 mt-0 mb-2" src="../assets/loghi/logo_icron_2.0.png" @click="gotoHome()" style="height: 40px" />
        <v-spacer></v-spacer>
        <!--img class="menuLogo ml-4 mt-2 mb-2" src="../assets/images/logoRacehard.png" style="height: 40px"   / -->
        <v-spacer></v-spacer>

        <span class="mr-4" v-if="isDesktopMode()">
            <v-icon @click="print()">print</v-icon>
        </span>
        <span  v-if="isDesktopMode()" class="mr-4">
            <v-icon @click="download()">download</v-icon>
        </span>
        <span v-if="showDownload && isAdmin()" class="mr-4">
            <v-icon color="red" @click="download(true)">download</v-icon>
        </span>
        <span v-if="isAdmin()" class="mr-4">
            <v-icon @click="forceReload()">refresh</v-icon>
        </span>
        <span class="mr-4" v-if="mostraSesso || mostraCategorie">
            <v-icon :class="getClasseFiltro()" @click="filtroDialog =true">filter_list</v-icon>
        </span>
        <span class="mr-2">
            <v-icon :class="filterToggle ? 'red--text': ''" @click="toggleSearch()">search</v-icon>
        </span>
        <!--v-icon
                v-if="filterPreferiti"
                class="mr-4 yellow--text"
                @click="togglePreferiti()"
                >star</v-icon
            >
            <v-icon v-else class="mr-4 yellow--text" @click="togglePreferiti()"
                >star_border</v-icon
            -->
        <!--span>
            <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
            <v-icon v-else @click="compatta = !compatta">expand</v-icon>
        </span-->
        <!--span>
            <v-icon @click="refreshData()">refresh</v-icon>
        </span-->
        <v-layout v-if="isDesktopMode()" align-start row wrap justify-center :class=" color + '  darken-2 p-2  v-toolbar--fixed'" style="width:100%; margin-top:55px">
            <span class="white--text"><strong>{{ rankTitle }} - {{getTipoVis()}} - {{this.divisioneCorrente}} {{getFilterDescription()}}</strong>
            </span>
        </v-layout>
        <v-layout v-if="isMobileMode()" align-center row wrap justify-center :class=" color + '  darken-2 p-2  v-toolbar--fixed white--text'" style="width:100%; margin-top:55px">
            <strong>{{ rankTitle }}</strong>
        </v-layout>
         <v-layout v-if="isMobileMode()" align-center row wrap justify-center class="bluIcron p-1  v-toolbar--fixed " style="width:100%; margin-top:75px">
           {{getTipoVis()}} - {{this.divisioneCorrente}} {{getFilterDescription()}}
        </v-layout>
        <!--v-layout v-if="isMobileMode()" align-end row wrap justify-end :class=" color + '  darken-2 p-2  v-toolbar--fixed ml-1'" style="margin-top:55px"> <strong>{{ raceTime }}</strong>
        </v-layout-->
    </v-toolbar>
    <v-progress-linear v-if="isDesktopMode() && pageScroll" background-color="white" color="#117C8A" class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>

    <v-layout v-if="isMobileMode() && configOK && configEvento.tipoVis == 'ASS'" align-start row wrap justify-center class="mb-4" style="margin-top:35px">
        <v-flex flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%; border: 0px">
                <template slot="items" slot-scope="props">
                    <tr style="height:1px">
                        <td style="height:1px" colspan="3"></td>
                    </tr>
                    <tr class="pa-2 " v-if="props.item.cognome !== ''">
                        <td colspan="4" class="cardUp pa-1" style="">
                            <strong style=" background-color: #0D3D58; color: white; 
                                                    float: left;
                                                    margin: -4px;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                <span v-if="isProgressivo()">{{ props.item.progressivo }}</span>
                                <span v-else-if="searchText == '' || searchText == null">{{ (props.index + 1) }}</span>
                                <span v-else>{{ getPosizione(props.item.pos)   }}</span>
                            </strong>
                            <span style="float: left">
                                <small class="ml-0 mr-2"></small>

                                <country-flag :country="props.item.nazione" size="small" />
                                <strong class="ml-1">{{ props.item.cognome }}
                                    {{ props.item.nome }}</strong>
                            </span>
                            <span @click="setCurrentItem(props.item)" class="mt-1 p-0" style="
                                                    float: right;
                                                    color: white;
                                                    margin-right: 10px;

                                                ">
                                <v-icon class="black--text pa-0">list</v-icon>
                            </span>
                            <br />
                            <span class="ml-3">  <small class="ml-3"> #{{ props.item.pett }} </small> <small class="ml-2"> {{
                                                    props.item.squadra
                                                }}   </small></span>

                        </td>
                    </tr>

                    <tr v-if="props.item.cognome !== ''">
                        <td width="3%" style="background-color: white;">
                            <small class="ml-2"></small>
                        </td>
                        <td width="37%" class="frazioniValueRow no-wrap">
                            <strong>{{ getValoreMobile(props.item, 'detailField_R10') }}</strong>
                        </td>
                        <td width="40%" class="frazioniValueRow ">
                            <strong>{{ getValoreMobile(props.item, 'detailField_R11') }}</strong>
                        </td>
                        <td width="20%" :class=" color +' white--text frazioniValueRow frazioniValueRowRounded no-wrap'">
                            <strong>{{ getValoreMobile(props.item, 'detailField_R12') }}</strong>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
     <v-layout v-if="isMobileMode() && configOK && configEvento.tipoVis !== 'ASS'" align-start row wrap justify-center class="mb-4" style="margin-top:35px">
        <v-flex flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%; border: 0px">
                <template slot="items" slot-scope="props">
                    <tr style="height:0px" v-if="isNewCat(props.item, props.index)">
                        <td colspan="3" style="height:0px" ></td>
                    </tr>
                    <tr class="pa-0 " v-if="isNewCat(props.item, props.index)">
                        <td colspan="3" align="center" class="frazioniValueRow pa-1" style="border-top: 3px solid #006064; ">
                            <strong style="color: #0D3D58;">{{props.item.cat}}</strong>
                        </td>
                    </tr>
                    
                    <tr  v-if="props.item.cognome !== ''">
                        <td width="1%" align="center" :class=" color +' white--text   no-wrap'">
                            <strong>{{ getValoreMobile(props.item, 'detailField_R11') }}</strong>
                        </td>
                        <td width="84%" style="background-color: white;">
                             <country-flag :country="props.item.nazione" size="small" /><small class="ml-2 no-wrap"><strong>{{ props.item.cognome }} {{ props.item.nome }}</strong></small>
                         <br />
                            <span class="ml-3">  <i><small class="ml-2"> {{
                                                    props.item.squadra
                                                }}   </small></i></span>
                        </td>
                        <td width="15%" class="lightgrey black--text frazioniValueRow  no-wrap'">
                            <strong><small>{{ getValoreMobile(props.item, 'detailField_R12') }}</small></strong>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
    <v-layout v-if="isDesktopMode() && configOK" align-start row wrap justify-center :class=" this.showButtons ? 'mt-4 ' : 'mt-1 ' ">
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
            <v-data-table :items="itemsF" hide-actions style="width: 100%;" class="mb-5">
                <template slot="headers" slot-scope="props">
                    <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                        <th v-if="isProgressivo()" class="black--text text-xs-center"><strong>POS</strong></th>
                        <th v-if="isFiltroEnabled()" class="black--text text-xs-center"><strong>POS</strong></th>
                        <th v-for="n in getFields() " :key="'intermedioTh'+n.id" class="black--text text-xs-center" @click="orderBy(n.name) "><strong>{{ n.label.toUpperCase() }}</strong></th>
                        <th align="center" ><v-icon small class="pa-0">visibility</v-icon></th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr style="height:0px">
                    </tr>
                     <tr v-if="isNewCat(props.item, props.index)">
                        <td :colspan="getFields().length -1" style="background-color: #f5f5f5 !important; height:20px" >
                           
                        </td>
                    </tr>
                     <tr v-if="isNewCat(props.item, props.index)">
                        <td :colspan="getFields().length +2"  style="border-top: 3px solid #006064; background-color: lightgrey !important; color: #0D3D58; height:20px" align="center" >
                            <strong >CATEGORIA - {{props.item.cat}}</strong>
                        </td>
                    </tr>
                     <!--tr v-if="isNewCat(props.item, props.index)">
                        <td v-if="isFiltroEnabled()" class="black--text text-xs-center"><strong>Pos</strong></td>
                        <td v-for="n in getFields() " :key="'intermedioTh'+n.id" class="black--text text-xs-center" @click="orderBy(n.name) "><strong>{{ n.label.toUpperCase() }}</strong></td>
                        <td align="center" ><v-icon small class="pa-0">visibility</v-icon></td>
                    </tr-->
                    <tr v-if="props.item.cognome !== ''">
                         <td v-if="isProgressivo()" :key="'intermedioRow_base'" style="text-align: center; color: white; background-color: #117C8A; font-weight: bold;"  >{{ props.item.progressivo  }}</td>
                        <td v-if="configEvento.tipoVis !== 'ASS'" style="text-align: center; color: white; background-color: #117C8A; font-weight: bold;">{{ props.item.pcat }} </td>
                        <td v-if="configEvento.tipoVis === 'ASS' && isFiltroEnabled()" style="text-align: center; color: white; background-color: #117C8A; font-weight: bold;">{{ props.index + 1 }} </td>
                        <td  v-for="n in getFields()" :key="'intermedioRow'+n.id" :style="n.style" :class="'no-wrap'">
                            <span v-if="n.label !== 'naz'">{{ getFieldValue(props.item, n) }}</span>
                            <span v-if="n.label === 'naz'">
                                <country-flag :country="props.item.nazione" size="small" /></span>
                        </td>
                        <td align="center" @click="setCurrentItem(props.item)" style="background-color: lightgrey; "><v-icon small class="black--text pa-0">list</v-icon></td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
    <v-layout v-if="!configOK " align-start row wrap justify-center class="mt-4 ">
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
            <v-layout class="justify-center">Caricamento classifica....</v-layout>
        </v-flex>
    </v-layout>
    <v-footer v-if="filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
        <v-layout align-start row wrap justify-center :class=" color + '  darken-2 p-0 m-0 '" style="width:100%; ">
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText" label="Cerca cognome, team o pettorale" outline clearable append-icon="search" @input="changedSearch"></v-text-field>
            </v-flex>
        </v-layout>
    </v-footer>
    <v-footer v-if="!filterToggle" fixed class="bluIcron" style="height: 30px; padding: 10px">

        <span class="mr-2" v-if="isDesktopMode()" @click="scrollToggle()">
                <v-icon  v-if="pageScroll" color="orange">pause</v-icon>
                <v-icon  v-else color="green">play_arrow</v-icon>
            </span>


        <span class="white--text ml-2" style="float:right"><span v-if="isDesktopMode()">Classificati:</span><span v-else><v-icon small color=white>people</v-icon></span><strong> {{itemsF.length}}</strong>  </span>
        
        
         <v-layout v-if="listaDivisioni.length > 0" align-end row wrap justify-end class="p-0 m-0 white--text">
            <span  class=" color + '  darken-2  mr-2  white--text pa-1' " style="border-radius: 5px" @click="cambiaGaraToggle = true">- Cambia gara -</span>
         </v-layout>
        <v-layout align-end row wrap justify-end class="p-0 m-0 white--text">
            <span class="mr-2  white--text pa-1"  @click="cambiaVisualizzazioneToggle = true"><span v-if="isDesktopMode()">Cambia visualizzazione</span><span v-else><v-icon color=white>list</v-icon></span></span>
            <!--span class="mr-2  white--text pa-1"  @click="cambiaVisualizzazione('LEAD')">Leaders</span -->
        </v-layout>
    </v-footer>
</div>
</template>

<script>
export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Classifica',

    data() {
        return {
            items: [],
            itemsF: [],
            itemsLead: [],

            showButtons: true,
            showPrint: false,
            showDownload: false,

            compatta: true,
            categoriaSelected: 'TUTTE',
            squadraSelected: 'TUTTE',
            nazioneSelected: 'TUTTE',
            sessoSelected: 'TUTTI',
            divisioneSelected: 'TUTTE',
            listaCategorie: [],
            listaSquadre: [],
            listaNazioni: [],
            listaSesso: ['TUTTI', 'MASCHILE', 'FEMMINILE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            listaCampi: [],
            listaCampiDettaglio: [],

            searchText: '',

            raceID: null,
            rankTitle: '',

            configEvento: {},
            elencoClassifica: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: null,

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            multiDivisione: false,
            mappaDivisioni: {},
            listaDivisioni: [],

            local: undefined,

            fields: [],
            detailFields: [],

            color: 'red',
            baseStyle: 'white:black',

            filtroDialog: false,

            orderByField: null,
            direction: true,

            configOK: false,

            numeroTotaleClassificati: 0,

            confDefault: false,

            cambiaGaraToggle: false,
            cambiaVisualizzazioneToggle: false,

            divisioneCorrente: '',

            pageScroll: false,

            filterDescription: undefined,

            mostraSesso: true,
            mostraCategorie: true,
            mostraSquadre: true,
            mostraNazione: false,

            scrollPage: 20,
            scrollInterval: 1,


        };
    },

    beforeDestroy() {
        //clearInterval(this.myInterval);
        // clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;
        this.local = this.$route.params.local;

        this.loadEvento();

         clearInterval(this.myIntervalBar);

    },

    methods: {
        isAdmin() {
            return false;
        },

        cambiaGara(divisione) {
            this.$router.push('/classifica/' + this.raceID + "/" + divisione + "/rank");
            window.location.reload();
        },

        cambiaVisualizzazione(vis) {
            if (vis == 'KIOSK') {
                this.$router.push('/self/' + this.raceID + "/" + this.paramID );
            } else {
                this.$router.push('/classifica/' + this.raceID + "/" + this.paramID + "/tipoVis="+vis+",numLeaders="+this.configEvento.numLeaders);
            window.location.reload();

            }
        },

        getDivisioni() {
            return this.listaDivisioni;
        },

        getVisualizzazioni() {
            
            return [
                { valore: 'ASS', descrizione: 'ASSOLUTA'},
                { valore: 'CAT', descrizione: 'CATEGORIE'},
                { valore: 'LEAD', descrizione: 'TOP ' + this.configEvento.numLeaders},
                { valore: 'KIOSK',  descrizione: 'KIOSK'}
            ];
        },

        toggleSearch() {
            this.filterToggle = !this.filterToggle;
            window.scrollTo(0, 0);
        },

        loadEvento() {
            this.elencoClassifica = [];
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=rankConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '' && response.indexOf('!DOCTYPE html') == -1) {
                    this.configRace(response);
                } else {
                    console.log("Configurazione di default")
                    const _url = this.getDataURL() + "getFile?idGara=base&fileName=rankConfigurationBASE.txt";;
                    console.log(_url);
                    this.getRemoteService(_url).then((response) => {
                        console.log(">>" + (response) + "<<");
                        this.confDefault = true;
                        if (response !== '') {
                            this.configRace(response);
                        } else {
                            alert("Nessuna configurazione disponibile");
                        }
                    });

                }
            }).catch(err => {
                alert("aaa")
            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

            if (this.configEvento.tipoVis == undefined) this.configEvento.tipoVis = "ASS";

            this.rankTitle = this.configEvento['rankTitle'];

            this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
            this.baseStyle = this.configEvento.baseStyle !== undefined ? this.configEvento.baseStyle : this.baseStyle;
            this.showButtons = (this.configEvento.showButtons !== undefined && this.configEvento.showButtons == 'false') ? false : true;
            this.showPrint = (this.configEvento.showPrint !== undefined && this.configEvento.showPrint == 'true') ? true : false;
            this.showDownload = (this.configEvento.showDownload !== undefined && this.configEvento.showDownload == 'true') ? true : false;

            this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
            this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false

            this.pageScroll = (this.configEvento.pageScroll !== undefined) ? (this.configEvento.pageScroll == 'true' ? true : false) : false
            this.scrollInterval = (this.configEvento.scrollInterval !== undefined) ?  parseInt(this.configEvento.scrollInterval)  : this.scrollInterval
            this.scrollPage = (this.configEvento.scrollPage !== undefined) ?  parseInt(this.configEvento.scrollPage)  : this.scrollPage

            this.fields = [];
            if (this.configEvento.tableFields !== undefined) {
                this.fields = this.configEvento.tableFields.split(",");
            }

            this.detailFields = [];
            if (this.configEvento.detailFields !== undefined) {
                this.detailFields = this.configEvento.detailFields.split(",");
            }

            this.getClassificaIcron(this.raceID, this.paramID).then((data) => {
                if (this.confDefault) {
                    this.rankTitle = data.evento.descrizione

                    this.fields = [];
                    if (data.elencoColonneTabella !== undefined) {
                        this.fields = data.elencoColonneTabella.toLowerCase().split(",");
                        this.detailFields = data.elencoColonneTabella.toLowerCase().split(",");
                         if (data.elencoLabelColonneExtra !== undefined) {
                             data.elencoLabelColonneExtra.forEach( key => {
                                 if (this.detailFields.indexOf(key.toLowerCase()) == -1)
                                    this.detailFields.push(key.toLowerCase())
                             })
                        }
                    }
                }
                this.numeroTotaleClassificati = data.elencoElementiClassifica.length;

                this.listaDivisioni = data.listaDivisioni.filter(elem => {
                    return elem.valore !== data.divisioneCorrente;
                })

                this.divisioneCorrente = data.divisioneCorrente;

                console.log("DIVISIONI:" + this.listaDivisioni)

                const de = data.evento.dataEvento.substring(0,10);
                this.dataEvento = de.substring(8,10)+"/"+de.substring(5,7)+"/"+de.substring(0,4)

                var mapSquadre = {};
                var mapCategorie = {};
                var mapCategorieWinner = {};

                this.items = [];

                this.elencoClassifica = [];
                this.listaCampiExtra = data.elencoLabelColonneExtra;
                this.colonneClassifica = data.elencoColonneTabella;

                for (var i = 0; i < data.elencoElementiClassifica.length; i++) {
                    var riga = data.elencoElementiClassifica[i];
                    //console.log(riga)
                    var rigaClassifica = {};
                    var index = 0;

                    rigaClassifica["pos"] = this.getPosizione(riga[0])  ;
                    rigaClassifica["pett"] = riga[1];
                    rigaClassifica["cognome"] = riga[2];
                    rigaClassifica["nome"] = riga[3];

                    rigaClassifica["atleta"] = riga[2] + " " + riga[3];

                    rigaClassifica["naz"] = riga[4];
                    rigaClassifica["sesso"] = riga[5];
                    rigaClassifica["p.sesso"] = riga[6];
                    rigaClassifica["cat"] = riga[7];
                    rigaClassifica["p.cat"] = riga[8];

                    if (this.configEvento.tipoVis == 'LEAD' && parseInt(riga[8]) > this.configEvento.numLeaders ) continue;

                    rigaClassifica["pcat"] = riga[8];
                    rigaClassifica["anno"] = riga[9];
                    rigaClassifica["squadra"] = riga[10];
                    rigaClassifica["tempo"] = riga[11];
                    rigaClassifica["tipoclass"] = riga[12];
                    rigaClassifica["distacco"] = riga[13];

                    if (riga.length > 14) {
                        for (let index = 0; index < riga.length; index++) {
                            const element = riga[index + 14];
                            //console.log(this.listaCampiExtra[index])
                            if (this.listaCampiExtra[index] !== undefined) {
                                const key = this.listaCampiExtra[index].toLowerCase();
                                rigaClassifica[key] = element;
                            }
                        }
                    }

                    if (
                        rigaClassifica["sesso"] == null ||
                        rigaClassifica["sesso"] == "" ||
                        rigaClassifica["sesso"] == "-"
                    )
                        rigaClassifica["sesso"] = "M"; // da eliminare

                    if (
                        rigaClassifica["tempo"] == null ||
                        rigaClassifica["tempo"] == "" ||
                        rigaClassifica["tempo"] == "null"
                    ) {
                        rigaClassifica["tempo"] = "-";
                    }
                    this.elencoClassifica.push(rigaClassifica)

                    if (rigaClassifica["naz"] == null || rigaClassifica["naz"] == "") {
                        rigaClassifica["naz"] = "ita";
                    } else if (rigaClassifica["naz"] == "it") {
                        rigaClassifica["naz"] = "ita";
                    }

                    if (rigaClassifica["naz"].length > 3) {
                        rigaClassifica["naz"] = rigaClassifica["naz"].substring(0,3);
                    } 

                    //rigaClassifica.flagPath =
                    //    _flagPath + rigaClassifica["naz"].toLowerCase() + ".png";
                    if (rigaClassifica["P.cat"] == 1) {
                        mapCategorieWinner[rigaClassifica["CAT"]] =
                            rigaClassifica["ATLETA"];
                    }

                    let numAtletiSquadra = mapSquadre[rigaClassifica["squadra"]];
                    if (numAtletiSquadra == null) {
                        mapSquadre[rigaClassifica["squadra"]] = parseInt(1);
                    } else {
                        mapSquadre[rigaClassifica["squadra"]] =
                            parseInt(numAtletiSquadra) + 1;
                    }

                    let numAtletiCat = mapCategorie[rigaClassifica["cat"]];
                    if (numAtletiCat == null) {
                        mapCategorie[rigaClassifica["cat"]] = parseInt(1);
                    } else {
                        mapCategorie[rigaClassifica["cat"]] = parseInt(numAtletiCat) + 1;
                    }

                    if (rigaClassifica["M/F"] == null || rigaClassifica["M/F"] === "")
                        rigaClassifica["M/F"] = rigaClassifica["POS"]; //forzo o M se null

                    /*if (rigaClassifica["sesso"] === "M") {
                        this.numeroTotaleClassificatiM++;
                        this.itemsM.push(rigaClassifica);
                        if (this.itemsTOPM.length == 5) continue;
                        else this.itemsTOPM.push(rigaClassifica);
                    } else if (rigaClassifica["sesso"] === "F") {
                        this.numeroTotaleClassificatiF++;
                        this.itemsF.push(rigaClassifica);
                        if (this.itemsTOPF.length == 5) continue;
                        else this.itemsTOPF.push(rigaClassifica);
                    }*/

                }

                //this.getRemoteService(_url).then((response) => {
                this.elencoClassifica = this.elencoClassifica.filter(elem => {
                    if (elem.categoria === undefined) {
                        elem.categoria = elem.cat
                    }

                    let res = true;
                    if (this.configEvento.filtroCategorie) {
                        const found = this.configEvento.filtroCategorie.split(",").find(element => element === elem.categoria);
                        res = found !== undefined;
                    }
                    if (res) {
                        if (this.configEvento.filtroDivisioni) {
                            //console.log("FILTRO DIVISIONI ATTIVO:" + this.configEvento.filtroDivisioni)
                            const found = this.configEvento.filtroDivisioni.split(",").find(element => element === elem.divisione);
                            res = found !== undefined;
                        }
                    }
                    if (this.configEvento.filtroPettorale !== undefined) {
                        const listaPett = this.configEvento.filtroPettorale.split(",");
                        const found = listaPett.find(element => element === elem.pett);
                        res = found !== undefined;
                    }

                    return res
                });

                this.mappaDivisioni = {};
                this.mappaMetriDivisioni = {};
                this.listaCategorie = [];
                let mappaCategorie = {};

                let mappaSesso = {};
                let mappaSquadre = {};
                let mappaNazioni = {};

                this.listaCategorie.push("TUTTE");
                this.listaNazioni.push("TUTTE");

                this.elencoClassifica.forEach(elem => {
                    if (elem.nazione == undefined) elem.nazione = elem.naz;
                    if (elem.nazione == undefined) elem.nazione = elem['naz.des.'];

                    if (elem.nazione && elem.nazione.length > 2) {
                        elem.nazione = elem.nazione.substring(0, 3).toLowerCase();
                    } else if (elem.nazione === undefined || elem.nazione === '') {
                        elem.nazione = 'ita';
                    }
                    elem.nazione = this.normalizeNaz(elem.nazione);

                    mappaNazioni[elem['nazione']] = elem['nazione'];


                    if (elem.pettorale !== undefined) {
                        elem.pett = elem.pettorale
                    } else if (elem.p !== undefined) {
                        elem.pett = elem.p
                    } else if (elem.dorsale !== undefined) {
                        elem.pett = elem.dorsale
                    } else if (elem.dors !== undefined) {
                        elem.pett = elem.dors
                    }

                    let mdiv = this.mappaDivisioni[elem['divisione']];
                    if (mdiv === undefined && elem['divisione'] != undefined) {
                        this.mappaDivisioni[elem['divisione']] = {
                            id: elem['divisione'],
                        };
                        //console.log("Divisione aggiunta: >>" + JSON.stringify(this.mappaDivisioni[elem['divisione']]) + "<<")
                    }
                    const _cc = elem['sesso'] + " - " + elem['categoria'];
                    mappaCategorie[_cc] = elem['categoria'];

                    mappaSesso[elem['sesso']] = elem['sesso'];
                    mappaSquadre[elem['squadra']] = elem['squadra'];
                    //console.log("Categoria aggiunta: >>" + mappaCategorie[_cc] + "<<")
                })

                this.mostraSesso = Object.keys(mappaSesso).length > 1;
                this.mostraCategorie = Object.keys(mappaCategorie).length > 1;
                this.mostraSquadre = Object.keys(mappaSquadre).length > 1;

                this.mostraNazione = Object.keys(mappaNazioni).length > 1;

                this.listaCategorie = Object.keys(mappaCategorie);
                if (this.listaCategorie.length > 1) {}
                //  }
                this.listaCategorie.sort();

                this.listaSquadre = Object.keys(mappaSquadre);
                this.listaSquadre.sort();


                this.listaNazioni = Object.keys(mappaNazioni);
                this.listaNazioni.sort();


                this.initFields();

                this.showClassifica();

                this.configOK = true;

                this.smoothToBottom();

                 if (this.configEvento.filterCat !== undefined) this.changedCategoria(this.configEvento.filterCat);
                 if (this.configEvento.filterGender !== undefined) this.changedSex(this.configEvento.filterGender);
                if (this.configEvento.numLeaders == undefined) this.configEvento.numLeaders = 5;
                 
                this.myIntervalBar = setInterval(this.refreshBar, 1000, this);
            });



        },

        refreshAll() {
            window.location.reload();
        },

        getField(item, key) {
            return item[this.getFieldName(key)];
        },

        getFieldValue(item, field) {
            if (field.columnName.indexOf("+") !== -1) {
                const cc = field.columnName.split("+");
                let campoComposto = "";
                cc.forEach(ele => {
                    campoComposto += item[ele] + " ";
                })
                return campoComposto;
            }

            return this.riduci(item[field.columnName])
        },

        getValoreMobile(item, key) {
            //console.log(key)
            const newKey = this.configEvento[key];
            if (newKey !== undefined && newKey.startsWith("'")) return newKey.replaceAll("'", "");
            return item[newKey];
        },

        getColumnName(field) {
            return field.columnName
        },

        getFieldName(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[0];
            }
            return key;
        },

        getFieldlabel(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[1];
            }
            return key;
        },

        getColor(colore) {
            if (colore === undefined) {
                colore = this.configEvento.baseStyle;
            }
            if (colore.indexOf(":") !== -1) {
                return colore.split(":")[0] + ' ' + colore.split(":")[1] + '--text '
            } else {
                return colore + ' white--text '
            }
        },

        setCurrentItem(item, colDef) {
            this.currentItem = item;
            this.dettaglio = true;
        },

        orderBy(field) {
            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },

        changedLabel(event) {
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedSex(event) {
            this.sessoSelected = event;

            this.itemsF = this.filteredList();
        },

        changedSquadra(event) {
            this.squadraSelected = event;
            this.itemsF = this.filteredList();
        },

         changedNazione(event) {
            this.nazioneSelected = event;
            this.itemsF = this.filteredList();
        },

        changedDivisione(event) {
            this.divisioneSelected = event;
            this.itemsF = this.filteredList();
        },

        changedSearch(event) {
            this.searchText = event;
            this.itemsF = this.filteredList();
        },

        changedCategoria(event) {
            this.categoriaSelected = event;
            this.itemsF = this.filteredList();
        },

        getTipoVis(){
            if (this.configEvento.tipoVis == 'ASS') return "ASSOLUTA";
            else if (this.configEvento.tipoVis == 'LEAD') return "TOP "+this.configEvento.numLeaders;
            else if (this.configEvento.tipoVis == 'CAT') return "CATEGORIE";
        },

        getFilterDescription(){
            let descr = "";
            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                 descr +=  this.categoriaSelected + " ";
            } 
            if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                 descr += " - " + this.sessoSelected + " ";
            }
            if (this.squadraSelected !== 'TUTTE' && this.squadraSelected !== undefined && this.squadraSelected !== '') {
                 descr += " - " + this.squadraSelected + " ";
            }
            if (this.nazioneSelected !== 'TUTTE' && this.nazioneSelected !== undefined && this.nazioneSelected !== '') {
                 descr += " - " + this.nazioneSelected + " ";
            }
            return descr;
        },

        scrollToggle() {
            this.pageScroll = !this.pageScroll
        },

        annullaFiltro() {
            this.sessoSelected = "TUTTI";
            this.categoriaSelected = "TUTTE";
            this.squadraSelected = "TUTTE";
            this.nazioneSelected = "TUTTE";
            this.filtroDialog = false;
            this.itemsF = this.filteredList();
        },

        isFiltroEnabled(){
            return this.getClasseFiltro() !== '' || this.configEvento.tipoVis == 'LEAD'  || this.configEvento.tipoVis == 'CAT';
        },

        isProgressivo(){
            return this.listaCampiExtra.indexOf("PROGRESSIVO") != -1
        },

        removeUndefined(value) {
            if (value == undefined) return "";
            return value;
        },

        showClassifica() {
            this.items = this.elencoClassifica;
            this.itemsF = this.filteredList();
        },

        gotoHome() {
            // this.$router.push('/classifiche');
        },

        getClasseFiltro() {
            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                return "red--text"
            } else if (this.squadraSelected !== 'TUTTE' && this.squadraSelected !== undefined && this.squadraSelected !== '') {
                return "red--text"
            } else if (this.nazioneSelected !== 'TUTTE' && this.nazioneSelected !== undefined && this.nazioneSelected !== '') {
                return "red--text"
            } else if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                return "red--text"
            }
            return ''
        },


        isNewCat(item, index) {
            if (this.configEvento.tipoVis == 'ASS') return false;
            if (index == 0 ) return true;
           // console.log(index+ ">>" + item.cat + "  " + this.items[index-1].cat + " = " + (item.cat !== this.items[index].cat))
            return (item.cat !== this.items[index-1].cat)
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                  /*  let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;*/
                    let res1 = false;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            //   console.log('categoriaSelected:' + this.categoriaSelected);

            if (this.categoriaSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    let _cat = this.categoriaSelected;
                    if (this.categoriaSelected.indexOf(" - ") !== -1) _cat = this.categoriaSelected.substring(this.categoriaSelected.indexOf(" - ") + 3);
                    
                    var res4 =
                        p != null &&
                        p.categoria != null &&
                        p.categoria == _cat;

                    return res4;
                });
            }

            //        console.log('sessoSelected:' + this.sessoSelected);

            if (this.sessoSelected !== 'TUTTI') {
                listaSearch = listaSearch.filter((p) => {
                    let sex = this.sessoSelected == 'MASCHILE' ? 'M' : 'F';
                    var res4 =
                        p != null &&
                        p.sesso != null &&
                        p.sesso == sex;

                    return res4;
                });
            }

            //       console.log('divisioneSelected:' + this.divisioneSelected);

            if (this.squadraSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase() == this.squadraSelected.toUpperCase();

                    return res4;
                });
            }

             if (this.nazioneSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.nazione != null &&
                        p.nazione.toUpperCase() == this.nazioneSelected.toUpperCase();

                    return res4;
                });
            }

            if ( this.configEvento.tipoVis !== 'ASS' ) {
                listaSearch.sort(this.simpleCompare);
            }

            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }

            if (this.configEvento.filtroRighe) listaSearch = listaSearch.slice(0, parseInt(this.configEvento.filtroRighe));

            return listaSearch;
        },

        getFields() {
            return this.listaCampi;
        },

        getDetailFields() {
            return this.listaCampiDettaglio;
        },

        getPosizione(pos) {
                if (pos == undefined) return "-"
                else if (pos == 999997) return "DNF"
                else if (pos == 999998) return "DSQ"
                else if (pos == 999999) return "DNS"
        
                return pos + "";
        },

        simpleCompare(a, b) {
            this.direction = -1;
            if (this.configEvento.tipoVis !== 'ASS')
                return this.compareField(a, b, 'cat')
        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        print() {
            let logo = this.configEvento.logoPath;
            let heightLogo = "50px"
            let raceDescription = ""

            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== ''){
                    raceDescription = this.categoriaSelected;
            }

            let tipoClass = "GENERALE";
            if (this.configEvento.tipoVis == 'CAT') tipoClass = "CATEGORIE";
            else if (this.configEvento.tipoVis == 'LEAD') tipoClass = "TOP " + this.configEvento.numLeaders;
          
		   let HEADERTABLE = "<p class=\"title2\" style=\"margin-top: 10px;text-align:right;  \"><img style=\"float:left\" src=\""+logo+"\" height=\""+heightLogo+"\"/>"+this.dataEvento+ "<br>"+ this.rankTitle  +"<br>Classifica "+tipoClass+"<br> " + this.divisioneCorrente + "<br>" +" <small style='float:right'> "+this.getFilterDescription()+"</small></p>";
            HEADERTABLE += "";
            const style2 = "<style>.classifica {font-family: Verdana;font-size: 11px;} .title {	font-family: Verdana;font-size: 20px;} .title2 {	font-family: Verdana;font-size: 16px; font-weight: bold; padding: 10px} td {	border-bottom:1px solid grey; vertical-align: top; }</style>";

            const myArray = this.itemsF.filter( elem => {
                return elem.cognome !== undefined;
            });
            var result = "<table width='100%' border=0 cellpadding=2>";
            result += "<tr class='classifica' bgcolor='#c0c0c0' >";

                if (this.isFiltroEnabled()) {
                    result += "<th class='black--text text-xs-center'>POS</th>"
                } 

                this.getFields().forEach(elem => {
                    result +=   "<td align=center nowrap><strong>" + elem.label.toUpperCase() + "</strong></td>"; +";"
                })

                result += "</tr>";
            for (var i = 0; i < myArray.length; i++) {
                if (this.isNewCat(myArray[i], i))  {
                    result += " <tr class='classifica'> <td colspan="+this.getFields().length +2 +"  align='center' ><br></td></tr>";
                }  
                if (this.isNewCat(myArray[i], i))  {
                    result += " <tr class='classifica'> <td colspan="+this.getFields().length +2 +" style='background-color: lightgrey !important; height:20px; border-top: 3px solid #006064; ' align='center' ><strong class='black--text'>CATEGORIA - " +myArray[i].cat+ "</strong></td></tr>";
                }   
                result += "<tr class='classifica' >";

                if (this.configEvento.tipoVis !== 'ASS') {
                    result += "<td style='text-align: center; color: white; background-color: #117C8A; font-weight: bold;' class='black--text text-xs-center'>"+myArray[i].pcat+"</td>"
                } else if (this.isFiltroEnabled()) {
                    result += "<td style='text-align: center; color: white; background-color: #117C8A; font-weight: bold;' class='black--text text-xs-center'>"+(i+1)+"</td>"
                } 
                //background-color:white !important; color:black !important
                this.getFields().forEach(elem => {
                    result += "<td align=right style=' "+elem.style+" ' nowrap>" + this.removeUndefined(this.getFieldValue(myArray[i], elem))+ "</td>";
                })
                
                result += "</tr>";
            }
            result += "</table>";

            let myWin = window.open("", "displayWindow", "width=800,height=500,status=yes,toolbar=yes,menubar=yes");

            myWin.document.open();
            myWin.document.write("<html><head><title>CLASSIFICA "+this.rankTitle +" " + this.divisioneCorrente +"</title>");
            myWin.document.write("");
            myWin.document.write("</head><body onload='window.print()'>");
            myWin.document.write(style2);
            
            myWin.document.write(HEADERTABLE);
            myWin.document.write(result);

            myWin.document.write("</body></html>");
            myWin.document.close();
        },

        download(){

            const myArray = this.itemsF;
            let result = "";

            this.getFields().forEach(elem => {
                    result +=  elem.label.toUpperCase() + ";";
            })
            result += "\n";

            for (var i = 0; i < myArray.length; i++) {
                this.getFields().forEach(elem => {
                    result += "" + this.removeUndefined(this.getFieldValue(myArray[i], elem))+ ";";
                })
                result += "\n";
            }

            
            //console.log(result)
            result = "data:text/csv;charset=utf-8," + result;


            let tipoClass = "GENERALE";
            if (this.configEvento.tipoVis == 'CAT') tipoClass = "CATEGORIE";
            else if (this.configEvento.tipoVis == 'LEAD') tipoClass = "TOP " + this.configEvento.numLeaders;


  
            var encodedUri = encodeURI(result);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "classifica_"+this.rankTitle  +"<br>Classifica "+tipoClass+"<br> " + this.divisioneCorrente+ ".csv");
            document.body.appendChild(link); // Required for FF
            
            link.click();
        },


        smoothToBottom() {
            const interval_id = window.setInterval(function () {}, Number.MAX_SAFE_INTEGER);
            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }
            // change the time to make the ani go faster or slower
            var scrollTimer = setInterval(this.scrollDown, this.scrollInterval*1000);

        },

        scrollDown() {
            if (this.pageScroll) {
                window.scrollBy(0, this.scrollPage);
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    window.scroll(0, 0);
                }
            }
        },

        refreshBar: function (self) {
            if (!self.pageScroll) return;
            if (self.value == undefined) self.value = 0;
           // console.log("refreshBar :" + self.value)
            self.value += (100 / (self.scrollInterval));
            //console.log(self.value);
            if (self.value > 100) self.value = 0;

        },

        downloadDiploma(item){
            let inputCriteria = {
                idGara: this.raceID,
                divisione: this.divisioneCorrente,
                pettorale: item.pett,
            };
            this.pdfData = undefined;
            this.controlLoadingSpinner(true);
            this.getDiploma(inputCriteria).then((data) => {
                this.controlLoadingSpinner(false);
               
                window.open("https://www.icron.it/" + data.path_risorsa);
                
            });
        },

        initFields() {
            console.log("initFields")

            if (this.fields.length > 0) {
                let colNum = 0;
                this.fields.forEach(elem => {
                    // console.log(elem)

                    let label = this.getFieldlabel(elem);
                    let name = this.getFieldName(elem);
                    let style = this.baseStyle;

                    const fieldStyle = this.configEvento['style_' + name];
                    if (fieldStyle !== undefined) {
                        let _st = fieldStyle.split(",");
                        if (_st.length > 0)
                            label = _st[0];
                        if (_st.length > 1)
                            style = _st[1];
                    }

                    const _obj = {
                        columnName: name,
                        label: label,
                        id: colNum++,
                        style: style
                    };
                    // console.log(_obj)
                    this.listaCampi.push(_obj);
                })
            }
            console.log(this.listaCampi)

            if (this.detailFields.length > 0) {
                let colNum = 0;
                this.detailFields.forEach(elem => {
                    let label = this.getFieldlabel(elem);
                    let name = this.getFieldName(elem);

                    if (name=='atleta' || name == 'cognome' || name == 'naz' || name == 'squadra' || name == 'pett') return;


                    let style = this.baseStyle;

                    const fieldStyle = this.configEvento['style_' + name];
                    if (fieldStyle !== undefined) {
                        let _st = fieldStyle.split(",");
                        if (_st.length > 0)
                            label = _st[0];
                        if (_st.length > 1)
                            style = _st[1];
                    }

                    const _obj = {
                        columnName: name,
                        label: label,
                        id: colNum++,
                        style: style
                    };
                    this.listaCampiDettaglio.push(_obj);
                })
            }
            console.log("CAMPI DETTAGLIO" + JSON.stringify(this.listaCampiDettaglio)) 
        }

    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
}


.bordoCat {
    text-align: center;
    background-color: rgb(243, 243, 243);
    border: 1px solid #006064
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
}

.frazioniValueRowRounded {
    border-radius: 0px 0px 10px 10px;
}

.bluIcron {
    color: white; 
    background-color: #0D3D58;
}

.cardUp {
    background-color: lightgray;
    color: #0D3D58;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardBottom {
    background-color: lightgray;
    color: #0D3D58;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
}

.cardStatsHeader {
    background-color: #0D3D58;
    color: white;
    border-radius: 5px 5px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 5px 5px 5px 5px;
}
</style>
